import { gql } from '../../../../../hooks'

export const READ_MODELS = gql`
  query AdministrationReadLubricantModels($id: ID!) {
    aRead(path: "lubricant/models", id: $id) {
    }
  }
`

export const UPDATE_MODELS = gql`
  mutation AdministrationUpdateLubricantModels($id: ID!, $data: JSONObject) {
    aUpdate(path: "lubricant/models", id: $id, data: $data) {
    }
  }
`

export const CREATE_MODELS = gql`
  mutation AdministrationCreateLubricantModels($data: JSONObject) {
    aCreate(path: "lubricant/models", data: $data) {
    }
  }
`

export const LIST_MODELS = gql`
  query AdministrationListLubricantModels(
    $page: Int
    $limit: Int
    $filter: JSONObject
  ) {
    aList(
      path: "lubricant/models"
      filter: $filter
      page: $page
      limit: $limit
    ) {
      pagination {
        page
        limit
        number_of_pages
      }
    }
  }
`

export const LIST_BRANDS = gql`
  query AdministrationMiscLubricantBrands {
    aLubricantBrands {
    }
  }
`

export const SEARCH_BRAND = gql`
  query AdministrationSearchLubricantBrand($text: String) {
    aSearch(path: "lubricant_brand", text: $text) {
    }
  }
`
